import React, { useEffect, useState } from 'react'
import { authService } from '../../common/service/auth.service'
import { useNavigate } from 'react-router-dom'
import ReactBeatLoader from '../../common/components/Spinner/ReactBeatLoader'

export interface IAuthRouteProps {
	children?: React.ReactNode
	publicRoute?: boolean // Add flag for public routes
}

const AuthRoute: React.FunctionComponent<IAuthRouteProps> = (props) => {
	const { children, publicRoute = false } = props
	const navigate = useNavigate()
	const [loading, setLoading] = useState(true) // Start with `true` to ensure auth check completes

	useEffect(() => {
		const checkAuth = async () => {
			if (publicRoute) {
				// Skip authentication check for public routes
				setLoading(false)
				return
			}

			const token = await authService.ensureValidToken()

			if (token) {
				if (window.location.pathname === '/login') {
					navigate('/welcome')
				}
			} else {
				navigate('/login')
			}
			setLoading(false)
		}

		checkAuth()
	}, [navigate, publicRoute])

	if (loading) return <ReactBeatLoader />

	return <>{children}</>
}

export default AuthRoute
